<fcom-notification class="block ps-large-b"
  >{{ 'MMB.checkIn.steps.passengerInfo.notificationText' | finLocalization }}
</fcom-notification>
<div
  *ngIf="
    (!modifyCheckIn && (notCheckedInPassengers$ | async)?.length > 1) ||
    (modifyCheckIn && (checkedInPassengers$ | async)?.length > 1)
  "
  data-testid="check-in-check-all-pax-checkbox"
  class="flex"
>
  <fcom-checkbox
    class="block ps-small-y"
    [checked]="allPaxSelectedCheckboxCheckedByDefault$ | async"
    (change)="checkInAllPassengers($event)"
  >
    <span>{{ 'MMB.checkIn.funnel.steps.passengers.checkInAllPassengers' | finLocalization }}</span>
  </fcom-checkbox>
</div>
<ng-container *ngIf="!modifyCheckIn && passengersWithCheckinInfo$ | async as passengersWithCheckInInfo">
  <form [formGroup]="applyForCheckInForm">
    <div
      *ngFor="let passenger of passengersWithCheckInInfo; let index = index; let first = first"
      class="mr-large-t border rounded-large nordic-blue-100-border white-bg"
    >
      <fin-check-in-passenger-info
        class="block ps-large-b"
        [trackingContext]="GaContext.CHECK_IN"
        [paxIndex]="index + 1"
        [passenger]="passenger"
        [passengersWithoutInfants]="passengersWithCheckInInfo"
        [controlData$]="controlData$"
        [formGroup]="applyForCheckInForm"
        [hideGroups]="true"
        [isMainPax]="(mainPaxInfo$ | finMap: 'id' | async) === passenger.id"
        [accompanyingAdult]="getAccompanyingAdult(passenger) | async"
        [accompanyingInfant]="getAccompanyingInfant(passenger) | async"
        [isSaving$]="updatingPassengers.includes(passenger.id) | finToObservable"
        [allFrequentFlyerCards$]="allFrequentFlyerCards$"
        (paxDetailsUpdating)="setUpdatingPassenger(passenger, $event)"
      ></fin-check-in-passenger-info>
    </div>
  </form>
</ng-container>
<ng-container *ngIf="modifyCheckIn && checkedInPassengers$ | async as checkedInPassengers">
  <form [formGroup]="applyForCheckInForm">
    <div
      *ngFor="let passenger of checkedInPassengers; let index = index; let first = first"
      class="mr-large-t border rounded-large nordic-blue-100-border white-bg"
    >
      <fin-check-in-passenger-info
        class="block ps-large-b"
        [trackingContext]="GaContext.CHECK_IN"
        [paxIndex]="index + 1"
        [passenger]="passenger"
        [passengersWithoutInfants]="checkedInPassengers"
        [modifyCheckIn]="true"
        [controlData$]="controlData$"
        [formGroup]="applyForCheckInForm"
        [hideGroups]="true"
        [isMainPax]="(mainPaxInfo$ | finMap: 'id' | async) === passenger.id"
        [accompanyingAdult]="getAccompanyingAdult(passenger) | async"
        [accompanyingInfant]="getAccompanyingInfant(passenger) | async"
        [isSaving$]="updatingPassengers.includes(passenger.id) | finToObservable"
        [allFrequentFlyerCards$]="allFrequentFlyerCards$"
        (paxDetailsUpdating)="setUpdatingPassenger(passenger, $event)"
      ></fin-check-in-passenger-info>
    </div>
  </form>
</ng-container>

<fcom-cta-button
  [visible]="true"
  [disabled]="(confirmEnabled$ | async) === false"
  [loading]="confirmButtonLoading$ | async"
  [title]="'MMB.checkIn.funnel.steps.passengers.button.confirmStep' | finLocalization"
  [position]="ButtonPosition.GRID_FULL"
  [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
  (buttonClicked)="confirmPassengersStep()"
>
  <span class="gray-50-text" data-testid="check-in-confirm-description">{{
    ((isAPISRequired$ | async)
      ? 'MMB.checkIn.funnel.steps.passengers.button.apisDescription'
      : 'MMB.checkIn.funnel.steps.passengers.button.description'
    ) | finLocalization
  }}</span>
</fcom-cta-button>
